/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Sun, Jul 25th 2021, 11:19:26 am
 *
 * *****************************************************
 */

import { LOGOUT_KEY } from 'constants/local-storage';

/**
 *  Trigger sync logging out but setting a flag in localStorage of other document
 */

export const syncLogout = () => {
  localStorage.setItem(LOGOUT_KEY, Date.now().toString());
};
